<div class="slider">
    <div><strong>Allow Parallel Milestones</strong></div>
    <mat-slide-toggle class="m-5" [(ngModel)]="isParallel" (change)="chartSlide()"
        [disabled]="disableGantChart$ | async"></mat-slide-toggle>
    <ng-container *ngIf="disableGantChart$ | async">
        <div><i>Parallel milestones are only supported for up to 4 phases</i></div>
    </ng-container>
</div>
<div class="chart-area">
    <div class="w-100 canvas-div">
        <canvas id="waterfall-chart"></canvas>
    </div>
</div>
<div class="d-flex align-items-center mt-3 mb-3">
    <div class="d-flex align-items-center mr-2">
        <div class="circle-legend green-circle"></div>
        <span class="legend-text ml-2">Low risk</span>
    </div>
    <div class="d-flex align-items-center mr-2">
        <div class="circle-legend yellow-circle"></div>
        <span class="legend-text ml-2">Medium risk</span>
    </div>
    <div class="d-flex align-items-center mr-2">
        <div class="circle-legend red-circle"></div>
        <span class="legend-text ml-2">High risk</span>
    </div>
</div>